
import { tidalTransitionExpand } from '@tidal/styles-animation';
import tidalIcon from '@tidal/styles-icons';

export default {
    components: {
        tidalTransitionExpand,
        tidalIcon,
    },
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        isClient: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: null,
        },
        subtitle: {
            type: [String, Boolean],
            default: false,
        },
        iconUrl: {
            type: String,
            default: null,
        },
        tidalIcon: {
            type: String,
            default: null,
        },
        faIcon: {
            type: String,
            default: null,
        },
        buttonAriaLabel: {
            type: String,
            default: null,
        },
        subscriptionType: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            /** @type {string | null} */
            id: 'null',
            /** @type {string | null} */
            headerId: null,
        };
    },
    computed: {
        hasRightHandContent() {
            return this.$slots['header-right'] || this.tidalIcon || this.iconUrl || this.faIcon;
        },
        hasPriceHeader() {
            return !!this.$slots['header-price'];
        },
        ariaExpandedValue() {
            return this.isOpen ? 'true' : 'false';
        },
    },
    mounted() {
        this.id = this.makeId(4);
        this.headerId = `heading_${this.id}`;
    },
    methods: {
        headerClick() {
            this.$emit('header-click');
        },
        /** @param {number} length */
        makeId(length) {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            const charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
    },
};
